import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=ec3ee20e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec3ee20e')) {
      api.createRecord('ec3ee20e', component.options)
    } else {
      api.reload('ec3ee20e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=ec3ee20e&", function () {
      api.rerender('ec3ee20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ShoSjoGPhL8q/JS/pricehelp.vue"
export default component.exports